<template>
	<div class="content">
		<div class="menu-list">
			<van-button type="primary" size="small" @click="addSomething">{{ addName }}</van-button>
			<van-button type="danger" size="small" @click="showDeleteButton = !showDeleteButton">{{
				showDeleteButton ? '关闭删除模式' : '删除模式' }}</van-button>
		</div>
		<van-tabs v-model="selectedModel">
			<van-tab title="材料配方管理">
				<div class="item-list">
					<span class="item" v-for="(baking) in bakingList" :key="baking.id">
						<span @click="getBakingDetail(baking.id)">{{ baking.name }}</span>
						<van-icon class="item-del" name="clear" v-show="showDeleteButton"
							@click="deleteBakingFromApi(baking.id)" /></span>
				</div>
			</van-tab>
			<van-tab title="材料管理">
				<div class="item-list">
					<span class="item" v-for="(bakingMaterial) in bakingMaterialList" :key="bakingMaterial.id">
						<span>{{ bakingMaterial.name }}</span>
						<van-icon class="item-del" name="clear" v-show="showDeleteButton"
							@click="deleteBakingMaterialFromApi(bakingMaterial.id)" /></span>
				</div>
			</van-tab>
			<van-tab title="单位管理">
				<div class="item-list">
					<span class="item" v-for="(unit) in unitList" :key="unit.id">
						<span>{{ unit.name }}</span>
						<van-icon class="item-del" name="clear" v-show="showDeleteButton"
							@click="deleteUnitFromApi(unit.id)" /></span>
				</div>
			</van-tab>
		</van-tabs>
		<van-popup v-model="showMaterialSelect" round :close-on-click-overlay="false">
			<van-picker title="选择材料" show-toolbar :columns="materialColumns" @confirm="onSelectMaterialConfirm"
				@cancel="showMaterialSelect = false" />
		</van-popup>
		<van-popup v-model="showMaterialUnitSelect" round :close-on-click-overlay="false">
			<van-picker title="选择单位" show-toolbar :columns="unitColumns" @confirm="onSelectUnitConfirm"
				@cancel="showMaterialUnitSelect = false" />
		</van-popup>
		<van-dialog class="add-menu" v-model="showDialog" :title="addName" showCancelButton @confirm="modifyData"
			@cancel="cleanBakingData" :beforeClose="beforeClose">
			<span class="add-material" @click="showAddMaterialDialog = true">添加材料</span>
			<span class="compute-material" @click="showComputedMaterial">计算配比</span>
			<van-field label-width="32" v-model="bakingName" input-align="center" placeholder="输入配方名字" />
			<div class="steps">
				<div class="step" v-for="(material, index) in materials" :key="material.id">
					<div class="big-step">
						<div class="material-name" @click="onSelected(material, true)"
							:style="{ color: material.name ? '#000000' : '#e1e1e3' }">
							{{ material.name || '选择材料' }}</div>
						<van-field size="small" v-model="material.count" type="number" label-width="32" rows="1"
							placeholder="原料数量" input-align="center" />
						<div class="material-unit" @click="onSelected(material, false)"
							:style="{ color: material.unit ? '#000000' : '#e1e1e3' }">
							{{ material.unit || '选择单位' }}</div>
						<van-icon name="clear" @click="deleteMaterial(material.id)" />
						<van-field size="small" v-model="computedMaterialsNums[index]" @input="inputComputedMaterial"
							@focus="targetMaterial = material" type="number" label-width="32" rows="1"
							placeholder="实际数量" input-align="center" />

					</div>
				</div>
			</div>
			<div class="add-new-step" @click="addMaterial()"><van-icon name="plus" />原料</div>
		</van-dialog>
		<van-dialog class="add-menu" v-model="showAddMaterialDialog" title="添加材料" showCancelButton
			@confirm="modifyMaterialData" @cancel="closeAddMaterialDialog" :beforeClose="beforeCloseAddMaterial">
			<van-field label-width="32" v-model="materialName" input-align="center" placeholder="输入材料名字" />
		</van-dialog>
		<van-dialog class="add-menu" v-model="showAddUnitDialog" title="添加单位" showCancelButton @confirm="modifyUnitData"
			@cancel="closeAddUnitDialog" :beforeClose="beforeCloseAddUnit">
			<van-field label-width="32" v-model="unitName" input-align="center" placeholder="输入单位名字" />
		</van-dialog>
	</div>
</template>

<script>
import {
	getBakingMaterialList,
	addBakingMaterial,
	getBakingList,
	updateBaking,
	deleteBaking,
	deleteBakingMaterial,
	getUnitList,
	addUnit,
	deleteUnit
} from '../util/api'
import { Notify, Dialog } from 'vant';
export default {
	name: 'Baking-Com',
	data() {
		return {
			selectedModel: 0,
			showDeleteButton: false,
			showMaterialSelect: false,
			showMaterialUnitSelect: false,
			showDialog: false,
			showAddMaterialDialog: false,
			showAddUnitDialog: false,
			materials: [],
			materialColumns: [],
			unitColumns: ['g', 'kg', 'ml', 'L'],
			bakingName: null,
			materialName: null,
			unitName: null,
			onEditMaterial: null,
			bakingList: [],
			unitList: [],
			bakingMaterialList: [],
			validBaking: false,
			validBakingMaterial: false,
			validUnit: false,
			operateBakingItem: null,
			computedMaterialsNums: [],
			targetMaterial: null,
			targetMaterialValue: null
		}
	},
	methods: {
		inputComputedMaterial(value) {
			this.targetMaterialValue = value ? Number(value) : null
		},
		computedMaterial() {
			const targetMaterialCount = this.targetMaterial?.count ? Number(this.targetMaterial?.count) : null
			if (!targetMaterialCount) {
				return
			}
			this.computedMaterialsNums = []
			if (!this.targetMaterialValue) {
				this.materials.forEach(() => {
					this.computedMaterialsNums.push(null)
				})
				return
			} else {
				const proportion = this.targetMaterialValue / targetMaterialCount
				this.materials.forEach((material) => {
					this.computedMaterialsNums.push((material.count * proportion).toFixed(2))
				})
			}
		},
		showComputedMaterial() {
			this.computedMaterial()
		},
		addSomething() {
			switch (this.selectedModel) {
				case 1:
					this.showAddMaterialDialog = true
					break
				case 2:
					this.showAddUnitDialog = true
					break
				default:
					this.showDialog = true
					break
			}
		},
		deleteBakingFromApi(id) {
			Dialog.confirm({
				message: '确认删除该配方吗'
			}).then(() => {
				deleteBaking({ id }).then(() => {
					this.getBakingListFromAPI()
				})
			}).catch(() => {
			});

		},
		deleteBakingMaterialFromApi(id) {
			Dialog.confirm({
				message: '确认删除该原料吗'
			}).then(() => {
				deleteBakingMaterial({ id }).then(() => {
					this.getBakingMaterialListFromApi()
				})
			}).catch(() => {
			});

		},
		deleteUnitFromApi(id) {
			Dialog.confirm({
				message: '确认删除该单位吗'
			}).then(() => {
				deleteUnit({ id }).then(() => {
					this.getUnitListFromApi()
				})
			}).catch(() => {
			});

		},
		getBakingDetail(id) {
			this.operateBakingItem = this.bakingList.find((baking) => baking.id === id)
			this.bakingName = this.operateBakingItem.name
			this.materials = this.operateBakingItem.materials
			this.showDialog = true
			this.initComputedMaterials();
		},
		modifyMaterialData() {
			addBakingMaterial({
				name: this.materialName
			}).then(() => {
				this.getBakingMaterialListFromApi();
			})
		},
		modifyUnitData() {
			this.validUnit = this.checkUnitValid()
			if (this.validUnit) {
				addUnit({
					name: this.unitName
				}).then(() => {
					this.getUnitListFromApi();
				})
			}

		},
		modifyData() {
			this.validBaking = this.checkBakingValid()
			if (this.validBaking) {
				updateBaking({
					...this.operateBakingItem,
					name: this.bakingName,
					materials: this.materials
				}).then(() => {
					this.getBakingListFromAPI()
					this.cleanBakingData()
				})
			}
		},
		beforeCloseAddMaterial(action, done) {
			if (action === 'confirm' && !this.materialName) {
				Notify({ type: 'danger', message: `第输入材料名称` });
				done(false)
			}
			done()
		},
		beforeCloseAddUnit(action, done) {
			if (action === 'confirm' && !this.validUnit) {
				done(false)
			}
			done()
		},
		checkUnitValid() {
			if (!this.unitName) {
				Notify({ type: 'danger', message: `第输入单位名称` });
				return false
			}
			if (this.unitList.some((unit) => unit.name === this.unitName)) {
				Notify({ type: 'danger', message: `单位名称已存在` });
				return false
			}
			return true
		},
		checkBakingValid() {
			const invalidDataIndex = this.materials.findIndex((material) => !material.name || !material.count || !material.unit)
			if (!this.bakingName) {
				Notify({ type: 'danger', message: `请输入配方名字` });
				return false
			}

			if (this.materials.length === 0) {
				Notify({ type: 'danger', message: `选择材料不能为空` });
				return false
			}
			if (invalidDataIndex > -1) {
				Notify({ type: 'danger', message: `第完善${invalidDataIndex + 1}条数据` });
				return false
			}
			return true
		},
		beforeClose(action, done) {
			if (action === 'confirm' && !this.validBaking) {
				done(false)
			}
			done()
		},
		closeAddMaterialDialog() {
			this.materialName = null
		},
		closeAddUnitDialog() {
			this.unitName = null
		},
		cleanBakingData() {
			this.bakingName = null
			this.materials = []
			this.initComputedMaterials();
		},
		initComputedMaterials() {
			this.computedMaterialsNums = []
			this.materials.forEach(() => {
				this.computedMaterialsNums.push(null)
			})
		},
		deleteMaterial(id) {
			this.materials = this.materials.filter((material) => material.id !== id)
		},
		onSelected(material, isName) {
			this.onEditMaterial = material;
			isName ? this.showMaterialSelect = true : this.showMaterialUnitSelect = true
		},
		onSelectMaterialConfirm(material) {
			this.showMaterialSelect = false
			this.updateSelectOptions('name', material);
		},
		onSelectUnitConfirm(unit) {
			this.showMaterialUnitSelect = false
			this.updateSelectOptions('unit', unit);
		},
		updateSelectOptions(key, value) {
			const newMaterials = this.materials.map((material) => {
				if (material.id === this.onEditMaterial.id) {
					return {
						...material,
						[key]: value
					}
				} else {
					return material
				}
			})
			this.$set(this, 'materials', newMaterials);
		},
		addMaterial() {
			const newMaterials = [...this.materials, {
				id: new Date().getTime(),
				name: null,
				unit: null,
				count: null,
				computedCount: null
			}]
			this.$set(this, 'materials', newMaterials);
		},
		getBakingListFromAPI() {
			getBakingList().then((res) => {
				this.bakingList = (res.data || []).map((item) => ({
					...item,
					materials: JSON.parse(item.materials).map((material) => ({
						...material,
						computedCount: null
					}))
				}))
			})
		},
		getBakingMaterialListFromApi() {
			getBakingMaterialList().then((res) => {
				this.bakingMaterialList = (res.data || [])
				this.materialColumns = this.bakingMaterialList.map((item) => item.name)
			})
		},
		getUnitListFromApi() {
			getUnitList().then((res) => {
				this.unitList = (res.data || [])
				this.unitColumns = this.unitList.map((item) => item.name)
			})
		}
	},
	mounted() {
		this.getBakingListFromAPI()
		this.getBakingMaterialListFromApi()
		this.getUnitListFromApi()
	},
	computed: {
		addName() {
			switch (this.selectedModel) {
				case 1:
					return '添加材料'
				case 2:
					return '添加单位'
				default:
					return '添加材料配方'
			}
		}
	}
}
</script>


<style scoped>
.content {
	/* Q版：柔和底色 + 贴纸卡片 */
	--q-bg0: #fff7fb;
	--q-bg1: #f2fbff;
	--q-card: rgba(255, 255, 255, 0.92);
	--q-line: rgba(15, 23, 42, 0.08);
	--q-shadow: 0 10px 24px rgba(17, 24, 39, 0.08);
	--q-shadow-sm: 0 6px 14px rgba(17, 24, 39, 0.08);
	--q-radius: 18px;
	--q-primary: #34c3ff;
	--q-primary-2: #6ee7ff;
	--q-danger: #ff5f7a;

	height: 100%;
	padding: 14px 14px 18px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	gap: 12px;
	position: relative;
	font-family: "Comic Sans MS", "Microsoft YaHei UI", "PingFang SC", "Hiragino Sans GB", system-ui, -apple-system,
		BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
	background: radial-gradient(120% 90% at 20% 0%, var(--q-bg0) 0%, transparent 60%),
		radial-gradient(120% 90% at 90% 30%, var(--q-bg1) 0%, transparent 55%),
		#ffffff;
}

.content::before,
.content::after {
	content: "";
	position: fixed;
	z-index: -1;
	pointer-events: none;
	opacity: 0.9;
}
.content::before {
	width: 240px;
	height: 240px;
	left: -90px;
	top: 140px;
	background: radial-gradient(circle at 30% 30%, rgba(255, 184, 220, 0.55), transparent 60%),
		radial-gradient(circle at 70% 70%, rgba(110, 231, 255, 0.45), transparent 62%);
	border-radius: 999px;
}
.content::after {
	width: 280px;
	height: 280px;
	right: -140px;
	bottom: 90px;
	background: radial-gradient(circle at 40% 30%, rgba(196, 255, 214, 0.5), transparent 60%),
		radial-gradient(circle at 70% 70%, rgba(255, 224, 170, 0.45), transparent 62%);
	border-radius: 999px;
}
/* 不要对 `.content > *` 统一加 position/z-index，会破坏 Vant Dialog/Popup 的 fixed 布局 */

.content /deep/ .van-button {
	border-radius: 999px;
	transition: transform 120ms ease, filter 120ms ease;
}
.content /deep/ .van-button:active {
	transform: translateY(1px) scale(0.985);
	filter: saturate(1.05);
}
.content /deep/ .van-button--primary {
	border: none;
	background: linear-gradient(180deg, var(--q-primary) 0%, var(--q-primary-2) 100%);
	box-shadow: 0 8px 18px rgba(52, 195, 255, 0.22);
}
.content /deep/ .van-button--danger {
	border: none;
	background: linear-gradient(180deg, #ff6b84 0%, var(--q-danger) 100%);
	box-shadow: 0 8px 18px rgba(255, 95, 122, 0.22);
}
.content /deep/ .van-dialog {
	border-radius: 18px;
	overflow: hidden;
}
.content /deep/ .van-dialog__confirm {
	border: none;
	background: linear-gradient(180deg, var(--q-primary) 0%, var(--q-primary-2) 100%);
	color: #fff;
	font-weight: 800;
}

.menu-list {
	display: flex;
	justify-content: space-around;
	border: 1px solid var(--q-line);
	border-radius: var(--q-radius);
	background: var(--q-card);
	box-shadow: var(--q-shadow-sm);
	padding: 10px 12px;
}

.step-box {
	display: flex;
	flex-direction: column;
	font-size: 12px;
	padding: 0 16px 16px;
	margin-top: 10px;
	gap: 18px;
	max-height: 280px;
	overflow: auto;
}

.content /deep/ .van-dialog__content {
	padding: 6px 12px;
}

.steps {
	overflow-y: auto;
	max-height: 450px;
}

.step {
	display: flex;
	flex-direction: column;
	padding: 8px 0;
}

.step .van-cell {
	padding: 0;
	margin-left: 2px;
	flex: 1;
	font-size: 12px;
	width: 80px;
	margin-top: 2px;
}

.step-box-title {
	font-size: 14px;
}

.add-new-step {
	font-size: 12px;
	color: rgba(107, 114, 128, 0.95);
	padding: 8px 10px;
	border: 1px dashed var(--q-line);
	border-radius: 12px;
	background: rgba(255, 255, 255, 0.7);
	text-align: center;
}

.sub-step {
	margin-left: 12px;
}

.big-step {
	display: flex;
	align-items: center;
	gap: 4px;
	font-size: 12px;
}

.material-name {
	flex: 1;
	margin-left: 4px;
	text-align: center;
}

.material-unit {
	width: 60px;
	margin-right: 4px;
	text-align: center;
}

.item-list {
	display: flex;
	gap: 8px;
	margin-top: 24px;
	flex-wrap: wrap;
}

.item-list {
	font-size: 12px;
	overflow-y: auto;
}

.item-list>span {
	padding: 6px 8px;
	border: 1px solid var(--q-line);
	border-radius: 12px;
	background: rgba(255, 255, 255, 0.86);
	box-shadow: 0 4px 10px rgba(17, 24, 39, 0.05);
}

.item-list .item-del {
	margin-top: 1px;
}

.item-list .item {
	display: flex;
	align-items: center;
	gap: 4px;
}

.add-material,
.compute-material {
	width: 60px;
	position: absolute;
	top: 28px;
	right: 12px;
	font-size: 12px;
	color: #f8a43c;
	border: 1px dotted;
	padding: 0 2px;
	text-align: center;
}

.add-material {
	left: 12px;
	color: #94e75e;
}

.computed-material {
	width: 56px;
	border: 0;
}
</style>
